
const holdout = "holdout-q2-ono";

const checkHoldout = _ => {
  const holdoutGroup = window._growthbook?.getFeatureValue(holdout, 'OFF');

  if (holdoutGroup === true) {
    document.documentElement.classList.add("ab-enabled");
    window.ab_enabled = true;
  }
};

const EXPERIMENT_KEY = 'cart_trust_builder';
const OVERRIDE_STORAGE_KEY = 'gb_trust_variant_override';
const OVERRIDE_URL_PARAM = 'gb_trust_variant';

const applyVariantAttribute = (variant) => {
  if (variant === 'v2' || variant === 'v3') {
    document.body.dataset.gbVariant = variant;
  } else {
    delete document.body.dataset.gbVariant;
  }
};

const readOverride = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const fromUrl = urlParams.get(OVERRIDE_URL_PARAM);
    if (fromUrl === 'off') {
      sessionStorage.removeItem(OVERRIDE_STORAGE_KEY);
      return null;
    }
    if (fromUrl !== null) {
      sessionStorage.setItem(OVERRIDE_STORAGE_KEY, fromUrl);
      return fromUrl;
    }
    return sessionStorage.getItem(OVERRIDE_STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

const persistVariantForTracking = (value) => {
 
  try {
    document.cookie = `gb_cart_trust_builder_variant=${value}; path=/; max-age=2592000; SameSite=Lax`;
  } catch (e) {}
  window.dataLayer = window.dataLayer || [];
  
  window.dataLayer.push({
    event: 'gb_variant_ready',
    gb_cart_trust_builder_variant: value,
  });
};

const applyCartTrustBuilder = (gb) => {

  const override = readOverride();
  if (override !== null) {
    window.ab_enabled = true;
    const variant = override === 'v2' || override === 'v3' ? override : 'control';
    applyVariantAttribute(variant);
    persistVariantForTracking(variant);
    return;
  }

  if (!window.ab_enabled) {
    applyVariantAttribute('control');
    persistVariantForTracking('holdout');
    return;
  }
  const rawVariant = window._growthbook?.getFeatureValue(EXPERIMENT_KEY, 'control');
  const variant = rawVariant === 'v2' || rawVariant === 'v3' ? rawVariant : 'control';
  applyVariantAttribute(variant);
  persistVariantForTracking(variant);
};


const setupCartTrustBuilderTracking = () => {
  const wrappers = document.querySelectorAll(`[data-growthbook-key="${EXPERIMENT_KEY}"]`);

  if ('IntersectionObserver' in window && wrappers.length) {
    const seen = new WeakSet();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          const detail = { variant: entry.target.dataset.variant };
          document.dispatchEvent(new CustomEvent('cart_trust_builder_viewed', { detail, bubbles: true }));
          if (window.dataLayer) {
            window.dataLayer.push({ event: 'cart_trust_builder_viewed', ...detail });
          }
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    wrappers.forEach((w) => io.observe(w));
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-tracking-event="cart_trust_builder_clicked"]');
    if (!link) return;
    const detail = {
      variant: link.dataset.variant,
      trust_builder_label: link.dataset.trustBuilderLabel,
    };
    document.dispatchEvent(new CustomEvent('cart_trust_builder_clicked', { detail, bubbles: true }));
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'cart_trust_builder_clicked', ...detail });
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupCartTrustBuilderTracking);
} else {
  setupCartTrustBuilderTracking();
}

(() => {
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    const applyFeatureFlags = () => {
      applyCartTrustBuilder(gb);
    };

    checkHoldout();

    applyFeatureFlags();
    document.addEventListener("growthbookdata", _ => {
      checkHoldout();
      applyFeatureFlags();
    });
  });
})();